import {
  Bug,
  Building2,
  CircleOff,
  FileStack,
  HandCoins,
  IdCard,
  MailWarning,
  MapPinOff,
  Scale,
  ThermometerSnowflake,
  X,
} from "lucide-react";

interface AbandonType {
  id: number;
  displayName: string;
}

const abandonIconById: Record<number, { Icon: typeof X; className: string }> = {
  1: { Icon: ThermometerSnowflake, className: "text-red-700" }, // CX
  2: { Icon: MapPinOff, className: "text-violet-700" }, // HC
  3: { Icon: Building2, className: "text-gray-700" }, // ENTERPRISE_DEACTIVATED
  4: { Icon: Bug, className: "text-orange-700" }, // BUG_ALGO
  5: { Icon: CircleOff, className: "text-zinc-700" }, // NOT_ELIGIBLE
  6: { Icon: Scale, className: "text-pink-700" }, // LOST_CASE
  7: { Icon: FileStack, className: "text-amber-700" }, // DUPLICATE
  8: { Icon: HandCoins, className: "text-teal-700" }, // ALREADY_COMPENSATED
  10: { Icon: MailWarning, className: "text-blue-700" }, // COMPENSATION_PROCEDURE_EXISTING
  11: { Icon: IdCard, className: "text-purple-700" }, // MISSING_PASSENGER_DOCUMENT
};

/** Port of AbandonTypeBadge.vue. */
export function AbandonTypeBadge({ abandonType }: { abandonType: AbandonType | null | undefined }) {
  if (!abandonType?.id) {
    return null;
  }

  const { Icon, className } = abandonIconById[abandonType.id] ?? {
    Icon: X,
    className: "text-red-700",
  };

  return (
    <div className="flex items-center gap-2">
      <Icon className={`h-4 w-4 ${className}`} />
      <span className="font-medium">{abandonType.displayName}</span>
    </div>
  );
}
